import { $, $$, byId } from './modules/dom.js';

const mod = (a, b) => ((a % b) + b) % b;

const parseSequence = (text, codeLines) => {
  const seq = [];
  let chunk = [];
  const seqLines = text.trim().split('\n').map(s => s.trim());
  for (let line of seqLines) {
    if (line === '') {
      if (chunk.length > 0) {
        seq.push(chunk);
        chunk = [];
      }
    } else {
      const [_, n, rest ] = line.match(/(\d+): ?(.*)/);
      let i = Number.parseInt(n) - 1;
      if (rest !== codeLines[i]) {
        throw new Error(`Sequence line ${rest} !== code line ${codeLines[i]}`);
      }
      chunk.push(Number.parseInt(n) - 1);
    }
  }
  if (chunk.length > 0) {
    seq.push(chunk);
  }
  return seq;
};

class CodeBuild {

  constructor(text, sequence, element) {
    this.lines = text.trim().split('\n');
    this.sequence = parseSequence(sequence, this.lines);
    this.element = element;
    this.gotoStep(0);
  }

  add(lines) {
    if (Array.isArray(lines)) {
      this.sequence.push(lines);
    } else if (typeof lines === 'number') {
      this.add([lines]);
    } else if (typeof lines === 'string') {
      const [s, e] = lines.split('-').map(x => Number.parseInt(x));
      this.add(Array.from({length: ((e - s) + 1)}, (_, i) => s + i));
    }
  }

  forward() {
    if (this.step < this.sequence.length) {
      this.gotoStep(this.step + 1);
    }
  }

  backward() {
    if (this.step > 0) {
      this.gotoStep(this.step - 1);
    }
  }

  gotoStart() {
    this.gotoStep(0);
  }

  gotoEnd() {
    // This is gross but it works to not highlight anything when you go to the
    // end.
    this.gotoStep(this.sequence.length);
  }

  gotoStep(step) {
    const allLines = this.sequence.slice(0, step + 1).flatMap(lines => lines).sort((a, b) => a - b);
    this.show(allLines, this.dataLines(allLines, step));
    this.step = step;
  }

  dataLines(allLines, step) {
    const current = new Set(this.sequence[step]);
    return allLines.flatMap((n, i) => current.has(n) ? [i + 1] : []);
  }

  show(allLines, dataLines) {
    const showing = new Set(allLines);
    this.element.parentElement.dataset.line = dataLines;
    this.element.textContent = this.lines.reduce((text, line, i) => {
      return showing.has(i) ? (text + `${line}\n`) : text;
    }, '');
    Prism.highlightElement(this.element);
  }

  showCurrent() {
    this.gotoStep(this.step);
  }

  isDone() {
    return this.step == this.sequence.length;
  }
};

const countNewlines = (s) => {
  let c = 0;
  for (let i = 0; i < s.length; i++) {
    if (s[i] === '\n') c++;
  }
  return c;
}

const scrollToHighlightedLines = (x) => {

  const lines = x.element.parentNode.dataset.line.split(',').map(s => Number.parseInt(s));
  const firstLine = lines[0] - 1;

  const walker = document.createTreeWalker(x.element, NodeFilter.SHOW_TEXT, null, false);

  let node = null;
  let lineNum = 0;
  while (node = walker.nextNode()) {
    lineNum += countNewlines(node.data);
    if (lineNum >= firstLine) {
      const toScroll = node.previousSibling || node.nextSibling || node.parentNode;
      toScroll.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      break;
    }
  }
};

Prism.hooks.add("after-highlight", scrollToHighlightedLines);

const doc = byId();

//document.documentElement.onclick = (e) => e.currentTarget.requestFullscreen();

fetch('language.txt')
  .then(r => r.text())
  .then(t => {
    const language = t.trim();
    $('#code').classList.add(`language-${language}`);
  });

fetch('files.txt')
  .then(r => r.text())
  .then(t => t.trim().split('\n'))
  .then(names => names.map(async n => {
    const basename = n.match(/^(.*)\.\w+$/)[1];
    const source = await fetch(n).then(r => r.text());
    const seq = await fetch(`${basename}-sequence.txt`).then(r => r.text());
    return new CodeBuild(source, seq, doc.code);
  }))
  .then(all => {
    Promise.all(all).then(classes => {
      const progressMarkers = classes.map(() => $('<span>'));
      progressMarkers.forEach(m => doc.progress.append(m));

      let which = window.location.hash ? Number.parseInt(window.location.hash.substring(1)) - 1 : 0;
      progressMarkers[which].classList.add('current');

      document.body.onkeydown = (e) => {

        if (e.key === 'ArrowRight') {
          if (e.shiftKey) { // Move to next class

            progressMarkers[which].classList.remove('current');
            which = mod(which + 1, classes.length);
            window.location.hash = `#${which + 1}`;
            progressMarkers[which].classList.add('current');
            classes[which].showCurrent();
          } else { // Show next segment of current class
            classes[which].forward();
          }
        } else if (e.key === 'ArrowLeft') {
          if (e.shiftKey) { // Move to previous class
            progressMarkers[which].classList.remove('current');
            which = mod(which - 1, classes.length);
            window.location.hash = `#${which + 1}`;
            progressMarkers[which].classList.add('current');
            classes[which].showCurrent();
          } else { // Show previous segment of current class
            classes[which].backward();
          }
        } else if (e.key === 'ArrowUp') {
          classes[which].gotoStart();
        } else if (e.key === 'ArrowDown') {
          classes[which].gotoEnd();
        }
      }
      classes[which].gotoStart();
    });
  });
